import { baseUrl, baseUrlRes1 } from "../constants/baseUrl";
import { apiGet, apiPost, apiPut, apiDelete } from "../library/helpers/apiHelper";
import { dedupeInFlight } from "../../common/utils/inflightRequests";
import axios from 'axios';
import cookieHelper from "../library/helpers/cookieHelper";

const getUsersList = async (opts = {}) => {
  try {
    const params = {};
    if (opts.serviceId != null && opts.serviceId !== "") {
      params.service_id = opts.serviceId;
    }
    // Restore legacy behavior: cache unscoped list; bypass cache when filtering by service (DMP).
    const useCache = Object.keys(params).length === 0;
    // The DMP dashboard mounts ModuleDashboardContext and SearchBar together, so this fires
    // twice at once for the same service. Sharing the pending request (rather than caching the
    // response) collapses them into one call while keeping every new mount a fresh fetch.
    // Key matches dmp-users-api.js so both modules share a single round trip.
    let response = await dedupeInFlight(
      `users:${params.service_id ?? "all"}`,
      () => apiGet("users", params, useCache)
    );

    
    let temp = [];
    // Check if response.users exists and is iterable
    if (response && response.users && Array.isArray(response.users)) {
      for (let user of response.users) {
        // Allow patients through if they have a first name OR an email (covers imported patients
        // whose name columns were blank — DmpUsersList falls back to email / "Patient {id}").
        if (user.first_name !== null || user.emailid != null) {
          temp.push({
            id: user.id,
            key: user.id,
          
            fullName: (user.first_name || '') + " " + (user.last_name || ''),
            firstName: user.first_name,
            lastName: user.last_name,
            mobileNo: Number(user.mobile_no),
            verify_status: user.Verify_status,
            emailId: user.emailid,
            dateOfBirth: user.dob,
            language: user.language,
            address1: user.address1,
            address2: user.address2,
            zipCode: user.zip_code,
            height_cm: user.height_cm,
            weight_lb: user.weight_lb,
            gender: user.gender,
            status: user.status,
            enrollment_status: user.enrollment_status,
            actStatus: user.status === "0" ? "Inactive" : "Active",
            isUser: true,
            createdOn: user.created_on,
            coach_role: user.coach_role,
            serviceData: [
              {
                key: 0,
                service: "weightloss",
                payment: "insurance",
                status: "pending",
                coach: "unassign",
                remark: "demo remark",
                paymentInfo: {
                  ins_provider_name: "null",
                  Ins_provider_id: "null",
                  Med_group_no: null,
                  verify_status: "null",
                },
              },
            ],

            paymentMethod: user.payment_method ? user.payment_method : "Insurance",
            // isApproved: true,
            coach: user.coach,
            staffId: user.coach_id,
            voip_device_token: user.voip_device_token,
            programme: user.program,
            avatar: user.image_url ? user.image_url : "https://t3.ftcdn.net/jpg/05/26/72/48/360_F_526724825_fEKkOFrsAnTBW3G5Qc9VCZxArl3zWEdT.jpg",
          });
        }
      }
    } else {
      console.error("API response doesn't contain users array:", response);
    }
    return temp;
  } catch (error) {
    console.error("Error in getUsersList:", error);
    return [];
  }
};

/** @param {number|string} staff_id
 *  @param {number|string|null} [serviceId] — this api file is also imported by Sleep/DME
 *  sidebars, so serviceId defaults to omitted (preserving their existing unscoped behavior).
 *  Restore's own callers pass 1 explicitly so Restore's sidebar doesn't mix in other
 *  modules' assigned patients. */
const getAssignedUsersList = async (staff_id, serviceId = null) => {
  try {
    const params = { staff_id: staff_id };
    if (serviceId != null && serviceId !== '' && !Number.isNaN(Number(serviceId))) {
      params.service_id = Number(serviceId);
    }
    const response = await apiGet("api/v1/getAssignedUsers", params);
    
    let temp = [];
    // Check if response.assignedUsers exists and is iterable
    if (response && response.assignedUsers && Array.isArray(response.assignedUsers)) {
      for (let user of response.assignedUsers) {
        if (user.user_first_name !== null) {
          temp.push({
            key: user.user_id,
            id: user.user_id,
            staff_id: user.staff_id,
            staff_name: user.staff_first_name + " " + user.staff_last_name,
            fullName: (user.user_first_name || '') + " " + (user.user_last_name || ''),
            language: user.language,
            date_assigned: user.date_assigned,
            created_on: user.created_on,
            coach_assigned_on: user.coach_assigned_on,
            emailid: user.emailid,
            avatar: user.image_url ? user.image_url : "https://t3.ftcdn.net/jpg/05/26/72/48/360_F_526724825_fEKkOFrsAnTBW3G5Qc9VCZxArl3zWEdT.jpg",
          });
        }
      }
      temp.sort((a, b) => new Date(b.date_assigned || b.coach_assigned_on || b.created_on || 0) - new Date(a.date_assigned || a.coach_assigned_on || a.created_on || 0));
    } else {
      console.error("API response doesn't contain assignedUsers array:", response);
    }
    return temp;
  } catch (error) {
    console.error("Error in getAssignedUsersList:", error);
    return [];
  }
};

/** NOTE: this previously took no parameters — several call sites pass a stray first
 *  argument (e.g. staffId) that was always silently ignored. To avoid misinterpreting one
 *  of those as a service filter, serviceId is read from a named options object instead of
 *  a positional argument: getAllAssignedUsersList({ serviceId: 1 }).
 *  @param {{ serviceId?: number|string|null }} [opts] */
const getAllAssignedUsersList = async (opts = {}) => {
  try {
    const { serviceId } = opts || {};
    const params = {};
    if (serviceId != null && serviceId !== '' && !Number.isNaN(Number(serviceId))) {
      params.service_id = Number(serviceId);
    }
    const response = await apiGet("api/v1/getAssignedUsers", params);
   
    
    let temp = [];
    // Check if response.assignedUsers exists and is iterable
    if (response && response.assignedUsers && Array.isArray(response.assignedUsers)) {
      for (let user of response.assignedUsers) {
        if (user.user_first_name !== null) {
          temp.push({
            key: user.user_id,
            id: user.user_id,
            staff_id: user.staff_id,
            staff_name: user.staff_first_name + " " + user.staff_last_name,
            fullName: (user.user_first_name || '') + " " + (user.user_last_name || ''),
            language: user.language,
            date_assigned: user.date_assigned,
            created_on: user.created_on,
            coach_assigned_on: user.coach_assigned_on,
            emailid: user.emailid,
            avatar: user.image_url ? user.image_url : "https://t3.ftcdn.net/jpg/05/26/72/48/360_F_526724825_fEKkOFrsAnTBW3G5Qc9VCZxArl3zWEdT.jpg",
          });
        }
      }
      temp.sort((a, b) => new Date(b.date_assigned || b.coach_assigned_on || b.created_on || 0) - new Date(a.date_assigned || a.coach_assigned_on || a.created_on || 0));
    } else {
      console.error("API response doesn't contain assignedUsers array:", response);
    }
    return temp;
  } catch (error) {
    console.error("Error in getAllAssignedUsersList:", error);
    return [];
  }
};

export const getTimerDetails = async (userId, staff_id, service_id) => {
  try {
    // The backend expects path parameters in this format
    // Ensure all parameters are defined and non-empty
    if (!userId || !staff_id || !service_id) {
      throw new Error("Missing required parameters for getTimerDetails");
    }
    
    // Use proper encoding for each path segment
    const encodedUserId = encodeURIComponent(userId);
    const encodedStaffId = encodeURIComponent(staff_id);
    const encodedServiceId = encodeURIComponent(service_id);
    
    // Make sure we're using the exact endpoint format required by the backend
    const endpoint = `api/v1/getLastSession/${encodedUserId}/${encodedStaffId}/${encodedServiceId}`;
   
    
    return await apiGet(endpoint, {}, false);
  } catch (error) {
    console.error("Error in getTimerDetails:", error);
    // Return a sensible default to prevent UI crashes
    return {
      status: "Error", 
      message: "Failed to fetch timer details",
      allTotalTime: 0 // Default value to prevent UI crashes
    };
  }
};

const postTimerDetails = async (data) => {
  return await apiPost("api/v1/addSession", data);
}

const getcompleteinfo = async (userId) => {
  return await apiGet(`api/v1/getcompleteUserDetails/${userId}`);
}

const updateUserWithId = async (data, userId) => {
  return await apiPut(`updateuser/${userId}`, data);
}

const assignCoachToUser = async (data) => {
  return await apiPut(`api/v1/updateUserCoach`, data);
};

const assignProviderToUser = async (data) => {
  return await apiPut(`api/v1/updateUserProvider`, data);
};

const getUserPaymentDetail = async (userId) => {
  const response = await apiGet(`web/users/${userId}`, {}, false);
  let user = response;
  let temp = {
    firstName: user.first_name,
    lastName: user.last_name,
    mobileNo: Number(user.mobile_no),
    emailId: user.emailid,
    dateOfBirth: user.dob?.slice(0, 10),
    language: user.language,
    address1: user.address1,
    address2: user.address2,
    zipCode: user.zip_code,
    height_cm: user.height_cm,
    weight_lb: user.weight_lb,
    gender: user.gender,
    paymentInfo: user.payment_info,
    coachInfo: user.coach_info,
    status: user.status ? user.status : "pending",
    coach: "unassign",
    programme: "Restore",

    avatar:
      "https://t3.ftcdn.net/jpg/05/26/72/48/360_F_526724825_fEKkOFrsAnTBW3G5Qc9VCZxArl3zWEdT.jpg",
  };

  return temp;
};

const getUserDetails = async (userId) => {
  return await apiGet(`web/users/${userId}`, {}, false);
};

const updatingUserPaymentMethodUsingPaymentId = async (paymentId, data) => {

  try {
    const result = await apiPut(`api/v1/updatePaymentMethod/${paymentId}`, data);
    
    return result;
  } catch (error) {
    console.error(`API error updating payment ${paymentId}:`, error);
    throw error;
  }
};

const updateMultipleUserCoach = async (data) => {
  return await apiPut("api/v1/updateUserCoachAssignedALL", data);
};

const updateMultiplePaymentInfo = async (staffId, data) => {
  return await apiPut("api/v1/updateMultiplePayments/" + staffId, data);
  // const url = baseUrlRes1 + "api/v1/updateMultiplePayments/" + staffId;
  // let response = await fetch(url, {
  //   method: "PUT",
  //   headers: {
  //     "Content-Type": "application/json",
  //   },
  //   body: JSON.stringify(data),
  // });
  // let p = await response.json();
  // if (response.ok) {
  //   return {
  //     msg: p.message,
  //     status: "success",
  //   };
  // } else {
  //   return {
  //     msg: "Can't update payment info at this moment",
  //     status: "error",
  //   };
  // }
};

const postUserPaymentDetails = async (data) => {
  try {
    
    // Don't double stringify - apiPost already stringifies the data
    const response = await apiPost("api/v1/createPaymentInformation", data);

    
    if (response.status === "Error") {
      return {
        msg: response.message || "Can't post payment info at this moment",
        status: "error",
      };
    }
    
    return {
      msg: response.message || "Payment information saved successfully",
      status: "success",
    };
  } catch (error) {
    console.error("Error in postUserPaymentDetails:", error);
    return {
      msg: "Can't post payment info at this moment",
      status: "error",
    };
  }
};

const postCoachToUser = async (data) => {
  try {
  
    // Don't double stringify - apiPost already stringifies the data
    const response = await apiPost("api/v1/assignCoach", data);
   
    
    if (response.status === "Error") {
      return {
        msg: response.message || "Can't post coach info at this moment",
        status: "error",
      };
    }
    
    return {
      msg: response.message || "Coach assigned successfully",
      status: "success",
    };
  } catch (error) {
    console.error("Error in postCoachToUser:", error);
    return {
      msg: "Can't post coach info at this moment",
      status: "error",
    };
  }
};

const deleteUserCoach = async (id) => {
  return await apiPut(`api/v1/deleteUserCoach/${id}`, { status: 0 });
};

const getUserMessages = async (userId) => {
  return await apiGet(`api/v1/getAlerts/${userId}`);
};

const getProgressByDateRangeAndUserId = async (userId, fromDate, toDate) => {
  return await apiGet(`api/v1/getProgressByDateRangeAndUserId/${userId}`, {
    from_date: fromDate,
    to_date: toDate
  });
};

///////////////////////////////////////
const getProgress = async (userId) => {
  return await apiGet(`api/v1/getProgress/${userId}`);
};

const getUserDevRead =async (userId, service_id, from, to) => {
  return await apiGet("api/v1/getUserDevRead", {
    user_id: userId,
    service_id,
    from,
    to
  });
};

////////////////////////////////////////////
const getAssignedGoals = async (userId) => {
  return await apiGet(`api/v1/web/users/${userId}/goals`);
};

const updateUserGoals = async (userId, goals) => {
  return await apiPut(`api/v1/users/${userId}/goals`, goals);
};

const createUserGoal = async (goalData) => {
  return await apiPost(`api/v1/taskGoaluser`, goalData);
};

const getFullNutrientInfo = async (userId, fromDate, toDate) => {
  return await apiGet("api/v1/getMealsInDateRange", {
    user_id: userId,
    from_date: fromDate,
    to_date: toDate
  });
};

const getUserCommunicationHistory = async (userId) => {
  return await apiGet(`api/v1/UserCommHist/getUserCommHist/${userId}`);
};

const addUserCommunicationHistory = async (data) => {
  return await apiPost("api/v1/UserCommHist/addUserCommHist", data);
};

const getUserCoachNotes = async (userId) => {
  return await apiGet(`api/v1/getUserCoachNotes/${userId}`);
};

const addUserCoachNote = async (data) => {
  return await apiPost("api/v1/addUserCoachNote", data);
};

const updateUserCoachNote = async (data) => {
  return await apiPut("api/v1/updateUserCoachNote", data);
};

const deleteUserCoachNote = async (noteId) => {
  return await apiDelete(`api/v1/deleteUserCoachNote/${noteId}`);
};

const patientDashboardApi = async (userId, service_id, from, to) => {
  return await apiGet("api/v1/getUserDevRead", {
    user_id: userId,
    service_id,
    from,
    to
  });
};

const getReadingSummary = async (userId, service_id) => {
  return await apiGet("api/v1/getUserDevSummary", {
    user_id: userId,
    service_id
  });
};

const getUserPaymentHistory = async (userId) => {
  return await apiGet(`payment-history/${userId}`);
};


const userDeactivationRequest = async (data) => {
  return await apiPost("api/v1/user-deactivation-request", data);
}

const getUserDeactivationRequests = async () => {
  return await apiGet("api/v1/user-deactivation-requests");
}

const handleUserDeactivationRequest = async (data) => {
  return await apiPost(`api/v1/user-deactivation-request/${data.id}/handle`, data);
}

const getDeactivatedUsers = async () => {
  return await apiGet("api/v1/deactivated-users");
}

// Circumference measurements API functions
const addCircumferenceMeasurements = async (data) => {
  return await apiPost("api/v1/addCircumferenceMeasurements", data);
};

const getCircumferenceMeasurements = async (userId, serviceId, fromDate, toDate) => {
  return await apiGet("api/v1/getCircumferenceMeasurements", {
    user_id: userId,
    service_id: serviceId,
    from_date: fromDate,
    to_date: toDate
  });
};

const updateCircumferenceMeasurement = async (data) => {
  return await apiPut("api/v1/updateCircumferenceMeasurement", data);
};

const deleteCircumferenceMeasurement = async (data) => {
  return await apiDelete("api/v1/deleteCircumferenceMeasurement", data);
};

const getCircumferenceStats = async (userId, serviceId, fromDate, toDate) => {
  return await apiGet("api/v1/getCircumferenceStats", {
    user_id: userId,
    service_id: serviceId,
    from_date: fromDate,
    to_date: toDate
  });
};

export {
  patientDashboardApi,
  getReadingSummary,
  postTimerDetails,
  
  getAssignedUsersList,
  getUsersList,
  updateUserWithId,
  assignCoachToUser,
  assignProviderToUser,
  getUserPaymentDetail,
  updatingUserPaymentMethodUsingPaymentId,
  getUserDetails,
  updateMultipleUserCoach,
  updateMultiplePaymentInfo,
  postUserPaymentDetails,
  postCoachToUser,
  deleteUserCoach,
  getUserMessages,
  getProgressByDateRangeAndUserId,
  getProgress,
  getAssignedGoals,
  updateUserGoals,
  createUserGoal,
  getFullNutrientInfo,
  getUserCommunicationHistory,
  addUserCommunicationHistory,
  getUserCoachNotes,
  addUserCoachNote,
  updateUserCoachNote,
  deleteUserCoachNote,
  getUserPaymentHistory,
  getcompleteinfo,
  getAllAssignedUsersList,
  getUserDevRead,
  userDeactivationRequest,
  getUserDeactivationRequests,
  handleUserDeactivationRequest,
  getDeactivatedUsers,
  addCircumferenceMeasurements,
  getCircumferenceMeasurements,
  updateCircumferenceMeasurement,
  deleteCircumferenceMeasurement,
  getCircumferenceStats,
  adminChangePassword
};

// Admin password change function
const adminChangePassword = async (payload) => {
  try {
    const token = cookieHelper.getToken() || localStorage.getItem('id_token');
    if (!token) {
      throw new Error('No authentication token found. Please log in again.');
    }
    
    const url = `${baseUrl}api/v1/adminChangePassword`;

    
    const response = await axios.post(url, payload, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error in adminChangePassword:', error);
    console.error('Request URL:', `${baseUrl}/api/v1/adminChangePassword`);
    console.error('Base URL:', baseUrl);
    throw error;
  }
};

export const getUserAppState = async (userId) => {
 
    const token = cookieHelper.getToken() || localStorage.getItem('id_token');
 
 
  const response = await axios.get(
    `${baseUrl}api/v1/users/app-state/${userId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
 
 
  return response.data;
};
